


























































































































import { ShowCaseCreditsListVueGB } from "@/extensions/products/ShowCaseCreditsListVueGB";
import BackLink from "@/components/app/BackLink.vue";
import Preloader from "@/components/app/Preloader.vue";
import { Component } from "vue-property-decorator";
import { ShowcaseInsurance } from "fs-pb-vue2/data/showcaseInsurance";

@Component({
  components: { BackLink, Preloader }
})
export default class ShowCaseCreditCalc extends ShowCaseCreditsListVueGB {

  async mounted(): Promise<void> {
    this.init();
    await this.initInsuranceSwitchers();
    //await this.calculateCredit();
  }
    
  async initInsuranceSwitchers() {
    this.calcInsurance = this.insurances.map(() => false);
	const defIns: ShowcaseInsurance | undefined = this.insurances.find((ins: ShowcaseInsurance) => ins.IsDefault === true);
    const defIndex: number | null = defIns ? this.insurances.indexOf(defIns) : null;

	if (defIndex !== null) {
		this.calcInsurance[defIndex] = true;
		await this.handleSwitchChange(defIndex);
	} else {
		this.calcInsurance[0] = true;
		await this.handleSwitchChange(0);
	}
  }
  
  async handleSwitchChange(index: number): Promise<void> {
	for (let i = 0; i < this.calcInsurance.length; i++) {
      if (i !== index) {
        this.calcInsurance[i] = false;
      } 
	}
	this.selectedInsuranceIndex = index;
    await this.calculateCredit();
  }

}
